// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive Design */
@media screen and (max-width: 1728px) {
  .scl--web-page-business-contact-container {
    padding: 100px var(--global-laptop-padding-left);
  }

  .scl--web-page-business-contact-content {
    gap: 60px;
  }
}

/* ==========================================
   Large Laptops (1440px and down)
   ========================================== */
@media screen and (max-width: 1440px) {
  .scl--web-page-business-contact-container {
    padding: 100px var(--global-laptop-padding-left);
  }

  .scl--web-page-business-contact-content {
    gap: 50px;
  }

  .scl--web-page-business-contact-left-section {
    max-width: 400px;
  }

  .scl--web-page-business-contact-right-section {
    flex: 1;
  }

  /* Form row - portrait layout */
  .scl--web-page-business-contact-form-row {
    flex-direction: column;
    gap: 15px;
  }

  .scl--web-page-business-contact-country-group,
  .scl--web-page-business-contact-phone-group {
    width: 100%;
    flex: none;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dropdown {
    width: 100%;
  }

  /* Actions row - stack vertically */
  .scl--web-page-business-contact-actions-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .scl--web-page-business-contact-submit-button {
    width: 100%;
  }

  .scl--web-page-business-contact-consent-group {
    gap: 20px;
  }
}

/* ==========================================
   Small Laptops (1280px and down)
   ========================================== */
@media screen and (max-width: 1280px) {
  .scl--web-page-business-contact-container {
    padding: 100px var(--global-laptop-padding-left);
    height: auto;
  }

  .scl--web-page-business-contact-content {
    flex-direction: column;
    gap: 40px;
  }

  .scl--web-page-business-contact-left-section {
    width: 100%;
    max-width: 100%;
  }

  .scl--web-page-business-contact-right-section {
    max-width: 100%;
    width: 100%;
  }

  .scl--web-page-business-contact-form {
    max-width: 100%;
    width: 100%;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {
    max-width: 100%;
    width: 100%;
  }

  /* Form row - back to same row */
  .scl--web-page-business-contact-form-row {
    flex-direction: row;
    gap: 10px;
  }

  .scl--web-page-business-contact-country-group {
    flex: 0 0 143px;
    width: 140px;
  }

  .scl--web-page-business-contact-phone-group {
    flex: 1;
    width: auto;
  }

  /* Actions row - back to same row */
  .scl--web-page-business-contact-actions-row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .scl--web-page-business-contact-submit-button {
    width: auto;
  }
}

/* ==========================================
   Tablets (850px and down)
   ========================================== */
@media screen and (max-width: 850px) {
  .scl--web-page-business-contact-container {
    padding: 120px var(--global-tablet-padding-left);
    height: auto;
  }

  .scl--web-page-business-contact-content {
    flex-direction: column;
    gap: 40px;
  }

  /* Title Section - 850px */
  .scl--web-page-business-contact-title {
    font-size: 70px;
    line-height: 110px;
    letter-spacing: -1.68px;
    font-weight: 400px;
  }

  .scl--web-page-business-contact-subtitle {
    font-size: 28px;
    line-height: 150%;
  }

  .scl--web-page-business-contact-left-section {
    width: 100%;
    max-width: 100%;
  }

  .scl--web-page-business-contact-right-section {
    max-width: 100%;
    width: 100%;
  }

  /* Country & Phone Row - 850px (stack vertically) */
  .scl--web-page-business-contact-form-row {
    flex-direction: column;
    gap: 10px;
  }

  .scl--web-page-business-contact-country-group,
  .scl--web-page-business-contact-phone-group {
    width: 100%;
    flex: none;
  }

  /* Form Container - Dark Card - 850px */
  .scl--web-page-business-contact-form {
    box-sizing: border-box;
    width: 779px;
    max-width: 100%;
    min-height: 670px;

    gap: 10px;
  }

  /* Form Inputs - 850px */
  .scl--web-page-business-contact-input,
  .scl--web-page-business-contact-select {
    box-sizing: border-box;
    width: 773px;
    max-width: 100%;
    height: 52px;
    background: transparent;
    border: 1px solid #7D8187;
    border-radius: 4px;
    font-size: 28px;
    line-height: 150%;
    color: #FFFFFF;
  }

  .scl--web-page-business-contact-input::placeholder,
  .scl--web-page-business-contact-select::placeholder {
    color: #7D8187;
    font-size: 28px;
  }

  /* Message Textarea - 850px */
  .scl--web-page-business-contact-textarea {
    box-sizing: border-box;
    width: 773px;
    max-width: 100%;
    height: 234px;
    min-height: 234px;
    background: transparent;
    border: 1px solid #7D8187;
    border-radius: 4px;
    font-size: 28px;
    line-height: 150%;
    color: #FFFFFF;
  }

  .scl--web-page-business-contact-textarea::placeholder {
    color: #7D8187;
    font-size: 28px;
  }

  /* Actions Row - 850px (stack vertically) */
  .scl--web-page-business-contact-actions-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 50px;
    width: 100%;
    margin-top: 40px;
  }

  /* File Upload Group - 850px */
  .scl--web-page-business-contact-file-upload-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    width: 100%;
  }

  /* Attach Button - 850px */
  .scl--web-page-business-contact-attach-button {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 0px;
    gap: 11px;
    width: 400px;
    height: 57px;
    background: transparent;
    opacity: 0.8;
    border: 1.5px solid #797979;
    border-radius: 30px;
  }

  .scl--web-page-business-contact-attach-button span,
  .scl--web-page-business-contact-attach-button .scl--web-component-round-button-text {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 100%;
    text-align: center;
    color: #FFFFFF;
  }

  /* Submit Button - 850px */
  .scl--web-page-business-contact-submit-button {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 0px;
    width: 779px;
    max-width: 100%;
    height: 58px;
    background: rgba(255, 255, 255, 0.2);
    border: 1.5px solid #797979;
    border-radius: 30px;
  }

  .scl--web-page-business-contact-submit-button span,
  .scl--web-page-business-contact-submit-button .scl--web-component-round-button-text {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 590;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #FFFFFF;
  }

  /* Consent Label - 850px */
  .scl--web-page-business-contact-consent-label {
    font-size: 28px;
    line-height: 150%;
  }

  /* File Info - 850px */
  .scl--web-page-business-contact-file-info {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 274;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -1px;
    color: #7D8187;
  }

  /* Switch Contact Card - 850px */
  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {
    box-sizing: border-box;
    width: 779px;
    max-width: 100%;
    height: 670px;
    background: #101010;
    border: 1.5px solid #252525;
    border-radius: 10px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-content-wrapper {
    width: 725px;
    max-width: 100%;
    gap: 141px;
    padding: 45px 27px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item {
    gap: 26px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item-content {
    gap: 45px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-description {
    font-size: 28px;
    line-height: 50px;
    color: #7D8187;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 20px;
    gap: 11px;
    width: 182px;
    height: 50px;
    background: #282828;
    border: 1.5px solid #797979;
    border-radius: 30px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button .scl--web-component-round-button-text {
    height: 30px;
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 100%;
    text-align: center;
    color: #FFFFFF;
  }

  /* Second button (Join us) with transparent background */
  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button {
    background: transparent;
    opacity: 0.8;
    width: 328px;
    height: 58px;
  }

  .scl--web-page-business-contact-consent-group {
    gap: 20px;
  }

  .scl--web-page-business-contact-consent-group .scl--web-component-checkbox-container{
    padding-top: 10px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-label {
    font-size: 28px;
    height: 40%;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input-plate .scl--web-component-text-field-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-text {
    font-size: 28px;
    line-height: 30px;
  }

  /* Country Select - 850px */
  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-label {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-input-plate .scl--web-component-country-select-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-text {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dial-code {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-label {
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate .scl--web-component-textarea-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input {
    min-height: 250px;
    font-size: 28px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate {
    min-height: 250px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-value-wrapper {
    min-height: 250px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-option-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-search-input {
    font-size: 20px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-search-input {
    font-size: 20px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-option-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dropdown {
    width: 100%;
  }

  .scl--web-component-textarea-character-count {

    font-size: 20px;
  }

  .scl--web-page-business-contact-consent-label .scl--web-page-business-contact-consent-label-bold {
    color: #FFFFFFCC;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button {
    width: 306px;
    height: 58px;
  }

}



@media screen and (max-width: 500px) {
  .scl--web-page-business-contact-container {
    padding: 150px var(--global-mobile-padding-left);
  }

  .scl--web-page-business-contact-contact-section {
    padding: 20px 0px 90px 0px;
  }

  .scl--web-page-business-contact-title {
    font-size: 55px;
    line-height: 60px;
    letter-spacing: -1.68px;
    color: #FFFFFF;
    padding-bottom: 10px;
  }

  .scl--web-page-business-contact-subtitle {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -1px;
    color: #7D8187;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {
    height: auto;
    min-height: 600px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-content-wrapper {
    gap: 100px;
  }

  /* File Upload Group - 500px (stack vertically) */
  .scl--web-page-business-contact-file-upload-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .scl--web-page-business-contact-actions-row {
    gap: 40px;
  }

  .scl--web-page-business-contact-attach-button {
    width: 100%;
  }

  .scl--web-page-business-contact-consent-group {
    gap: 20px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-label {
    font-size: 24px;
    height: 40%;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input-plate .scl--web-component-text-field-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-text {
    font-size: 24px;
  }

  /* Country Select - 850px */
  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-input-plate .scl--web-component-country-select-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-text {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dial-code {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate .scl--web-component-textarea-label.floating {
    font-size: 18px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input {
    min-height: 250px;
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate {
    min-height: 250px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-value-wrapper {
    min-height: 250px;
  }

  .scl--web-page-business-contact-consent-label {
    font-size: 24px;
    line-height: 150%;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-description {
    font-size: 24px;
    line-height: 100%;
    color: #7D8187;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-option-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-search-input {
    font-size: 20px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-search-input {
    font-size: 20px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-option-label {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button {
    width: 100%;
    height: 56px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button .scl--web-component-round-button-text {
    height: 25px;
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    text-align: center;
    color: #FFFFFF;
  }

  .scl--web-page-business-contact-attach-button span,
  .scl--web-page-business-contact-attach-button .scl--web-component-round-button-text {
    font-size: 24px;
  }

  .scl--web-page-business-contact-submit-button span,
  .scl--web-page-business-contact-submit-button .scl--web-component-round-button-text {
    font-size: 24px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button{
    width: 100%;
    height: 49px;
  }

  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button{
    width: 100%;
    height: 49px;
  }

}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/bussiness-contact/css/businessContactResponsive.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;EACT;;EAEA,+BAA+B;EAC/B;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA,mDAAmD;EACnD;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,UAAU;EACZ;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;;IAEjB,SAAS;EACX;;EAEA,wBAAwB;EACxB;;IAEE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,WAAW;EACb;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,oCAAoC;IACpC,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;EAChB;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,wDAAwD;EACxD;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;AAEF;;;;AAIA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA,iDAAiD;EACjD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF","sourcesContent":["/* Responsive Design */\n@media screen and (max-width: 1728px) {\n  .scl--web-page-business-contact-container {\n    padding: 100px var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-business-contact-content {\n    gap: 60px;\n  }\n}\n\n/* ==========================================\n   Large Laptops (1440px and down)\n   ========================================== */\n@media screen and (max-width: 1440px) {\n  .scl--web-page-business-contact-container {\n    padding: 100px var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-business-contact-content {\n    gap: 50px;\n  }\n\n  .scl--web-page-business-contact-left-section {\n    max-width: 400px;\n  }\n\n  .scl--web-page-business-contact-right-section {\n    flex: 1;\n  }\n\n  /* Form row - portrait layout */\n  .scl--web-page-business-contact-form-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .scl--web-page-business-contact-country-group,\n  .scl--web-page-business-contact-phone-group {\n    width: 100%;\n    flex: none;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dropdown {\n    width: 100%;\n  }\n\n  /* Actions row - stack vertically */\n  .scl--web-page-business-contact-actions-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n\n  .scl--web-page-business-contact-submit-button {\n    width: 100%;\n  }\n\n  .scl--web-page-business-contact-consent-group {\n    gap: 20px;\n  }\n}\n\n/* ==========================================\n   Small Laptops (1280px and down)\n   ========================================== */\n@media screen and (max-width: 1280px) {\n  .scl--web-page-business-contact-container {\n    padding: 100px var(--global-laptop-padding-left);\n    height: auto;\n  }\n\n  .scl--web-page-business-contact-content {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .scl--web-page-business-contact-left-section {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .scl--web-page-business-contact-right-section {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .scl--web-page-business-contact-form {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  /* Form row - back to same row */\n  .scl--web-page-business-contact-form-row {\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .scl--web-page-business-contact-country-group {\n    flex: 0 0 143px;\n    width: 140px;\n  }\n\n  .scl--web-page-business-contact-phone-group {\n    flex: 1;\n    width: auto;\n  }\n\n  /* Actions row - back to same row */\n  .scl--web-page-business-contact-actions-row {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .scl--web-page-business-contact-submit-button {\n    width: auto;\n  }\n}\n\n/* ==========================================\n   Tablets (850px and down)\n   ========================================== */\n@media screen and (max-width: 850px) {\n  .scl--web-page-business-contact-container {\n    padding: 120px var(--global-tablet-padding-left);\n    height: auto;\n  }\n\n  .scl--web-page-business-contact-content {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  /* Title Section - 850px */\n  .scl--web-page-business-contact-title {\n    font-size: 70px;\n    line-height: 110px;\n    letter-spacing: -1.68px;\n    font-weight: 400px;\n  }\n\n  .scl--web-page-business-contact-subtitle {\n    font-size: 28px;\n    line-height: 150%;\n  }\n\n  .scl--web-page-business-contact-left-section {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .scl--web-page-business-contact-right-section {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  /* Country & Phone Row - 850px (stack vertically) */\n  .scl--web-page-business-contact-form-row {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .scl--web-page-business-contact-country-group,\n  .scl--web-page-business-contact-phone-group {\n    width: 100%;\n    flex: none;\n  }\n\n  /* Form Container - Dark Card - 850px */\n  .scl--web-page-business-contact-form {\n    box-sizing: border-box;\n    width: 779px;\n    max-width: 100%;\n    min-height: 670px;\n\n    gap: 10px;\n  }\n\n  /* Form Inputs - 850px */\n  .scl--web-page-business-contact-input,\n  .scl--web-page-business-contact-select {\n    box-sizing: border-box;\n    width: 773px;\n    max-width: 100%;\n    height: 52px;\n    background: transparent;\n    border: 1px solid #7D8187;\n    border-radius: 4px;\n    font-size: 28px;\n    line-height: 150%;\n    color: #FFFFFF;\n  }\n\n  .scl--web-page-business-contact-input::placeholder,\n  .scl--web-page-business-contact-select::placeholder {\n    color: #7D8187;\n    font-size: 28px;\n  }\n\n  /* Message Textarea - 850px */\n  .scl--web-page-business-contact-textarea {\n    box-sizing: border-box;\n    width: 773px;\n    max-width: 100%;\n    height: 234px;\n    min-height: 234px;\n    background: transparent;\n    border: 1px solid #7D8187;\n    border-radius: 4px;\n    font-size: 28px;\n    line-height: 150%;\n    color: #FFFFFF;\n  }\n\n  .scl--web-page-business-contact-textarea::placeholder {\n    color: #7D8187;\n    font-size: 28px;\n  }\n\n  /* Actions Row - 850px (stack vertically) */\n  .scl--web-page-business-contact-actions-row {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 50px;\n    width: 100%;\n    margin-top: 40px;\n  }\n\n  /* File Upload Group - 850px */\n  .scl--web-page-business-contact-file-upload-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0px;\n    gap: 8px;\n    width: 100%;\n  }\n\n  /* Attach Button - 850px */\n  .scl--web-page-business-contact-attach-button {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 0px;\n    gap: 11px;\n    width: 400px;\n    height: 57px;\n    background: transparent;\n    opacity: 0.8;\n    border: 1.5px solid #797979;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-business-contact-attach-button span,\n  .scl--web-page-business-contact-attach-button .scl--web-component-round-button-text {\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: 400;\n    font-size: 28px;\n    line-height: 100%;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n  /* Submit Button - 850px */\n  .scl--web-page-business-contact-submit-button {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 0px;\n    width: 779px;\n    max-width: 100%;\n    height: 58px;\n    background: rgba(255, 255, 255, 0.2);\n    border: 1.5px solid #797979;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-business-contact-submit-button span,\n  .scl--web-page-business-contact-submit-button .scl--web-component-round-button-text {\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: 590;\n    font-size: 24px;\n    line-height: 29px;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n  /* Consent Label - 850px */\n  .scl--web-page-business-contact-consent-label {\n    font-size: 28px;\n    line-height: 150%;\n  }\n\n  /* File Info - 850px */\n  .scl--web-page-business-contact-file-info {\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: 274;\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: -1px;\n    color: #7D8187;\n  }\n\n  /* Switch Contact Card - 850px */\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {\n    box-sizing: border-box;\n    width: 779px;\n    max-width: 100%;\n    height: 670px;\n    background: #101010;\n    border: 1.5px solid #252525;\n    border-radius: 10px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-content-wrapper {\n    width: 725px;\n    max-width: 100%;\n    gap: 141px;\n    padding: 45px 27px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item {\n    gap: 26px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item-content {\n    gap: 45px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-description {\n    font-size: 28px;\n    line-height: 50px;\n    color: #7D8187;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 20px;\n    gap: 11px;\n    width: 182px;\n    height: 50px;\n    background: #282828;\n    border: 1.5px solid #797979;\n    border-radius: 30px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button .scl--web-component-round-button-text {\n    height: 30px;\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: 400;\n    font-size: 28px;\n    line-height: 100%;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n  /* Second button (Join us) with transparent background */\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button {\n    background: transparent;\n    opacity: 0.8;\n    width: 328px;\n    height: 58px;\n  }\n\n  .scl--web-page-business-contact-consent-group {\n    gap: 20px;\n  }\n\n  .scl--web-page-business-contact-consent-group .scl--web-component-checkbox-container{\n    padding-top: 10px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-label {\n    font-size: 28px;\n    height: 40%;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input-plate .scl--web-component-text-field-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-text {\n    font-size: 28px;\n    line-height: 30px;\n  }\n\n  /* Country Select - 850px */\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-label {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-input-plate .scl--web-component-country-select-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-text {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dial-code {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-label {\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate .scl--web-component-textarea-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input {\n    min-height: 250px;\n    font-size: 28px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate {\n    min-height: 250px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-value-wrapper {\n    min-height: 250px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-option-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-search-input {\n    font-size: 20px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-search-input {\n    font-size: 20px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-option-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dropdown {\n    width: 100%;\n  }\n\n  .scl--web-component-textarea-character-count {\n\n    font-size: 20px;\n  }\n\n  .scl--web-page-business-contact-consent-label .scl--web-page-business-contact-consent-label-bold {\n    color: #FFFFFFCC;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button {\n    width: 306px;\n    height: 58px;\n  }\n\n}\n\n\n\n@media screen and (max-width: 500px) {\n  .scl--web-page-business-contact-container {\n    padding: 150px var(--global-mobile-padding-left);\n  }\n\n  .scl--web-page-business-contact-contact-section {\n    padding: 20px 0px 90px 0px;\n  }\n\n  .scl--web-page-business-contact-title {\n    font-size: 55px;\n    line-height: 60px;\n    letter-spacing: -1.68px;\n    color: #FFFFFF;\n    padding-bottom: 10px;\n  }\n\n  .scl--web-page-business-contact-subtitle {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -1px;\n    color: #7D8187;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-card-container {\n    height: auto;\n    min-height: 600px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-content-wrapper {\n    gap: 100px;\n  }\n\n  /* File Upload Group - 500px (stack vertically) */\n  .scl--web-page-business-contact-file-upload-group {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .scl--web-page-business-contact-actions-row {\n    gap: 40px;\n  }\n\n  .scl--web-page-business-contact-attach-button {\n    width: 100%;\n  }\n\n  .scl--web-page-business-contact-consent-group {\n    gap: 20px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-label {\n    font-size: 24px;\n    height: 40%;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input-plate .scl--web-component-text-field-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-text-field-input {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-input-plate .scl--web-component-select-field-text {\n    font-size: 24px;\n  }\n\n  /* Country Select - 850px */\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-input-plate .scl--web-component-country-select-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-text {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-dial-code {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate .scl--web-component-textarea-label.floating {\n    font-size: 18px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input {\n    min-height: 250px;\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-input-plate {\n    min-height: 250px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-textarea-value-wrapper {\n    min-height: 250px;\n  }\n\n  .scl--web-page-business-contact-consent-label {\n    font-size: 24px;\n    line-height: 150%;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-description {\n    font-size: 24px;\n    line-height: 100%;\n    color: #7D8187;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-option-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-select-field-search-input {\n    font-size: 20px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-search-input {\n    font-size: 20px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-country-select-option-label {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button {\n    width: 100%;\n    height: 56px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-button .scl--web-component-round-button-text {\n    height: 25px;\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 100%;\n    text-align: center;\n    color: #FFFFFF;\n  }\n\n  .scl--web-page-business-contact-attach-button span,\n  .scl--web-page-business-contact-attach-button .scl--web-component-round-button-text {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-submit-button span,\n  .scl--web-page-business-contact-submit-button .scl--web-component-round-button-text {\n    font-size: 24px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:first-child .scl--web-component-switch-contact-button{\n    width: 100%;\n    height: 49px;\n  }\n\n  .scl--web-page-business-contact-contact-section .scl--web-component-switch-contact-item:last-child .scl--web-component-switch-contact-button{\n    width: 100%;\n    height: 49px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
